"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const ConfirmationModal = ({ title, titleIconVariant, content, confirmationButtonText = 'Yes', confirmationButtonVariant = 'danger', onClose, onConfirm, }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (React.createElement(react_core_1.Modal, { title: title, titleIconVariant: titleIconVariant, isOpen: true, onClose: onClose, variant: react_core_1.ModalVariant.small, actions: [
            React.createElement(react_core_1.Button, { "data-testid": "confirm-modal-submit", key: "confirm", variant: confirmationButtonVariant, onClick: onConfirm }, confirmationButtonText),
            React.createElement(react_core_1.Button, { key: "cancel", variant: "link", onClick: onClose }, t('ai:Cancel')),
        ] }, content));
};
exports.default = ConfirmationModal;
//# sourceMappingURL=ConfirmationModal.js.map